export default function fullname(userOrEmployee) {
  if (!userOrEmployee) return '';

  return [userOrEmployee.firstName, userOrEmployee.lastName]
    .filter(Boolean)
    .join(' ');
}
